import React from 'react';

// Importing icons to match the image
import AssessmentIcon from '@material-ui/icons/Assessment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

const SUMMARY_METRICS = [
    { label: 'Bottling Requirement', value: '12.25M', delta: '+0.45M vs base plan', tone: 'blue', icon: <AssessmentIcon />, deltaTone: 'warn' },
    { label: 'Feasible Bottling', value: '12.10M', delta: '98.8% of requirement', tone: 'green', icon: <CheckCircleIcon />, deltaTone: 'good' },
    { label: 'Peak Line Load', value: '96%', delta: 'South L2', tone: 'purple', icon: <WarningIcon />, deltaTone: 'bad' },
    { label: 'Value Protected', value: '₹12 Cr', delta: 'through rebalancing', tone: 'orange', icon: <AttachMoneyIcon />, deltaTone: 'good' },
];

const BOTTLING_PLAN_DATA = [
    { site: 'North L1', basePlan: '1.45M', latestNeed: '1.62M', capacity: '1.70M', optimized: '1.60M', load: '94%' },
    { site: 'West L1', basePlan: '1.32M', latestNeed: '1.40M', capacity: '1.55M', optimized: '1.42M', load: '92%' },
    { site: 'South L2', basePlan: '1.48M', latestNeed: '1.70M', capacity: '1.55M', optimized: '1.49M', load: '96%' },
    { site: 'East L2', basePlan: '1.18M', latestNeed: '1.02M', capacity: '1.35M', optimized: '1.08M', load: '80%' },
    { site: 'Central L1', basePlan: '0.94M', latestNeed: '1.05M', capacity: '1.25M', optimized: '1.08M', load: '86%' },
];

const CONSTRAINTS_DATA = [
    { constraint: 'South L2', change: '96% load', action: 'Shift 60k' },
    { constraint: '750ml glass', change: '-55k', action: 'Advance PO' },
    { constraint: 'Premium bulk', change: '91% cover', action: 'Prioritize mix' },
    { constraint: 'East capacity', change: '20% flex', action: 'Absorb volume' },
    { constraint: 'Changeovers', change: '48', action: 'Resequence' },
];

export class BottlingCapacity extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Bottling & Capacity Optimizer</h1>
                        <p>Rebalance bottling across sites and lines as demand, bulk and packaging constraints change.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the image style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: Bottling Plan vs Capacity */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Bottling Plan vs Capacity</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Site / Line</th>
                                    <th>Base Plan</th>
                                    <th>Latest Need</th>
                                    <th>Capacity</th>
                                    <th>Optimized</th>
                                    <th>Load</th>
                                </tr>
                            </thead>
                            <tbody>
                                {BOTTLING_PLAN_DATA.map((row) => (
                                    <tr key={row.site}>
                                        <td>{row.site}</td>
                                        <td>{row.basePlan}</td>
                                        <td>{row.latestNeed}</td>
                                        <td>{row.capacity}</td>
                                        <td>{row.optimized}</td>
                                        <td>{row.load}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="cc-management-question" style={{marginTop: "20px"}}>
                            <EmojiObjectsIcon className="cc-mgmt-icon" />
                            <span>Demand-driven changes: shift volume away from constrained South; use East/Central flex; resequence packs to reduce changeovers.</span>
                        </div>
                        
                        
                    </div>

                    {/* Right Panel: Constraint-Driven Line Rebalancing */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Constraint-Driven Line Rebalancing</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Constraint</th>
                                    <th>Change</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {CONSTRAINTS_DATA.map((row) => (
                                    <tr key={row.constraint}>
                                        <td>{row.constraint}</td>
                                        <td>{row.change}</td>
                                        <td className="cc-action-link">{row.action}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default BottlingCapacity;